import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';

/**
 * Filtra i pagamenti con flValido true da un elenco di pagamenti con dettaglio.
 */
export function getValidPayments(
  payments: PagamentoWithDettaglioDTO[] | null | undefined,
): PagamentoWithDettaglioDTO[] {
  return payments?.filter(p => p.flValido) ?? [];
}
